<!--
SPDX-FileCopyrightText: 2024 Comcast

SPDX-License-Identifier: LicenseRef-Comcast
-->

<button class="cee-btn cee-tag merc-timer" [ngClass]="styleClass | async" data-qa="timer">
    {{ timeLabel }}
</button>